export default __webpack_public_path__ + "static/logo-246f61207f498b9debc1f828fcdb751c.png";